import CurrencyChooserProvider from './src/CurrencyChooserProvider';

export const wrapRootElement = ({ element }) => (
  <CurrencyChooserProvider>{element}</CurrencyChooserProvider>
);
